export default defineNuxtPlugin((nuxtApp) => {
	const { $credentialApiService, $messages } = useNuxtApp()
	const credentialStore = useCredentialStore()
	const selectedQrEventId = useState("selectedQrEventId", () => null)
	const toastStore = useToastStore()
	const transferStore = useTransferStore()

	nuxtApp.provide("credentialService", {
		$transfer: async (credentialIds, firstname, lastname, email, phone) => {
			const requestBody = {
				credential_ids: credentialIds,
				recipient: {
					first_name: firstname,
					last_name: lastname,
					email: email,
					phone: phone,
				},
			}

			const successHandler = (res) => {
				//The response is an updated list of credentials owned by the user

				//Each cred that is not in the response has been transferred away
				const currentCredIds = res.data.map((cred) => cred.id)
				const credsBeforeTransfer = credentialStore.getCredentials()
				for (const cred of credsBeforeTransfer) {
					const isCredStillOwned = currentCredIds.includes(cred.id)
					if (!isCredStillOwned) {
						transferStore.addTransferredItem(cred)
					}
				}

				credentialStore.clear()
				credentialStore.storeCredentialsFromJson(res.data)
				toastStore.setSuccess($messages.$t("transferSuccess"))
				transferStore.setOnStep(99)
				navigateTo("/transferComplete")
			}

			await $credentialApiService.$transfer(requestBody, successHandler)
		},

		$claim: async (eventId, ticketId, lodgingId) => {
			const requestBody = {
				event_id: eventId,
				ticket_credential_id: ticketId,
				lodging_credential_id: lodgingId,
			}

			const successHandler = (res) => {
				credentialStore.clear()
				credentialStore.storeCredentialsFromJson(res.data)
				selectedQrEventId.value = eventId
				toastStore.setSuccess($messages.$t("claimSuccess"))
				navigateTo("/myQrCode")
			}

			await $credentialApiService.$claim(requestBody, successHandler)
		},

		$unclaim: async (eventId) => {
			const requestBody = {
				event_id: eventId,
			}

			const successHandler = async (res) => {
				credentialStore.clear()
				credentialStore.storeCredentialsFromJson(res.data)
				selectedQrEventId.value = eventId
				toastStore.setSuccess($messages.$t("unclaimSuccess"))
				navigateTo("/myQrCode")
			}

			await $credentialApiService.$unclaim(requestBody, successHandler)
		},
	})
})
